import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedLetterO = createReactComponent('outline', 'square-rounded-letter-o', 'SquareRoundedLetterO', __iconNode);

export default IconSquareRoundedLetterO;